import { useTheme } from '../../hooks/useTheme'

const ThemeToggle = ({ className = '' }) => {
  const { isDark, toggleTheme } = useTheme()

  return (
    <button
      onClick={toggleTheme}
      className={`
        relative w-14 h-7 rounded-full
        bg-slate-200 dark:bg-slate-700
        transition-colors duration-300
        focus:outline-none focus:ring-2 focus:ring-zenna-violet focus:ring-offset-2
        ${className}
      `}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      {/* Track icons */}
      <span className="absolute inset-0 flex items-center justify-between px-1.5">
        {/* Sun icon */}
        <svg 
          className={`w-4 h-4 transition-opacity ${isDark ? 'opacity-30' : 'opacity-0'}`}
          fill="none" 
          viewBox="0 0 24 24" 
          stroke="#fbbf24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
        </svg>
        {/* Moon icon */}
        <svg 
          className={`w-4 h-4 transition-opacity ${isDark ? 'opacity-0' : 'opacity-30'}`}
          fill="none" 
          viewBox="0 0 24 24" 
          stroke="#7c3aed"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
        </svg>
      </span>

      {/* Sliding circle */}
      <span 
        className={`
          absolute top-0.5 w-6 h-6 rounded-full
          bg-white shadow-md
          transition-all duration-300 ease-in-out
          flex items-center justify-center
          ${isDark ? 'left-7' : 'left-0.5'}
        `}
      >
        {isDark ? (
          <svg className="w-4 h-4 text-slate-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
          </svg>
        ) : (
          <svg className="w-4 h-4 text-amber-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
          </svg>
        )}
      </span>
    </button>
  )
}

export default ThemeToggle
